const lightThemeClass = 'light';

export const initializeToggleTheme = () => {
    const toggleClassesConfig = [{
        containers: document.querySelectorAll('.js-hover-toggle-theme'),
        toggleOnEvent: 'mouseenter',
        toggleOffEvent: 'mouseleave'
    }];

    toggleClassesConfig.forEach(config => {
        if (!config.containers.length) return;

        config.containers.forEach(container => {
            container.addEventListener(config.toggleOnEvent, () => {
                container.classList.add(lightThemeClass);
            });

            container.addEventListener(config.toggleOffEvent, () => {
                container.classList.remove(lightThemeClass);
            });
        })
    });
}
